import React from 'react';
import {
  ISelectOptionDataSource,
  ISelectOption,
  ISelectOptionsProps,
} from './types';

const toSelectOption = (item: ISelectOptionDataSource): ISelectOption => ({
  value: item.id ? item.id.toString() : '',
  label: item.name,
});

export const toSelectOptions = (
  data: Array<ISelectOptionDataSource>,
): Array<ISelectOption> => data.map(toSelectOption);

export const SelectOptions: React.FC<ISelectOptionsProps> = ({ options }) => {
  const renderOption = (option: ISelectOption) => (
    <option key={option.value} value={option.value}>
      {option.label}
    </option>
  );

  if (!options) return null;

  return <>{options.map(renderOption)}</>;
};
